import Component from "./Component.js"

export default class ContextMenu extends Component {

  constructor(props, context) {
    super(props, context)
  }

  static get contextTypes() {
    return super.contextTypes
  }

  render() {
    const menuItems = [
      <li className="amp-context-item amp-bold" key="0">Akamai Adaptive Media Player</li>,
      <li className="amp-context-item" key="1">{this.player.version}</li>
    ]

    if ((typeof akamaiGetViewerId == "function") && (akamaiGetViewerId() != null))
      menuItems.push(<li className="amp-context-item amp-selectable" key="2">Viewer ID: {akamaiGetViewerId()}</li>)

    const style = {
      top: `${this.props.y}px`,
      left: `${this.props.x}px`
    }

    return (
      <ul ref="element" className="amp-context-menu" style={style}>
        {menuItems}
      </ul>
    )
  }
}
